import { useTranslation } from 'react-i18next';
import { Charger } from '../types';
import { Zap, Clock, WifiOff, List, Users } from 'lucide-react';

interface ChargerFilterProps {
  currentFilter: 'all' | 'available' | 'busy' | 'offline' | 'queueable';
  onFilterChange: (filter: 'all' | 'available' | 'busy' | 'offline' | 'queueable') => void;
  chargers: Charger[];
}

export function ChargerFilter({ currentFilter, onFilterChange, chargers }: ChargerFilterProps) {
  const { t } = useTranslation();
  const safeChargers = chargers || [];
  
  const counts = {
    all: safeChargers.length,
    available: safeChargers.filter(c => c.online && c.status === 'idle').length,
    busy: safeChargers.filter(c => c.online && c.status !== 'idle').length,
    offline: safeChargers.filter(c => !c.online).length,
    queueable: safeChargers.filter(c => c.canJoinQueue && c.queueLength < 4).length,
  };

  const filters = [
    { 
      key: 'all' as const, 
      label: t('home.filters.all'), 
      count: counts.all,
      icon: <List size={16} />
    },
    { 
      key: 'available' as const, 
      label: t('home.filters.available'), 
      count: counts.available,
      icon: <Zap size={16} />
    },
    { 
      key: 'busy' as const, 
      label: t('home.filters.busy'), 
      count: counts.busy,
      icon: <Clock size={16} />
    },
    { 
      key: 'queueable' as const, 
      label: t('home.filters.queueable'), 
      count: counts.queueable,
      icon: <Users size={16} />
    },
    { 
      key: 'offline' as const, 
      label: t('home.filters.offline'), 
      count: counts.offline,
      icon: <WifiOff size={16} />
    },
  ];

  return (
    <div className="modern-filter-section">
      <div className="modern-filter-tabs">
        {filters.map(({ key, label, count, icon }) => (
          <button
            key={key}
            className={`modern-filter-tab ${currentFilter === key ? 'active' : ''} ${key}`}
            onClick={() => onFilterChange(key)}
          >
            <span className="filter-icon">{icon}</span>
            <span className="filter-label">{label}</span>
            <span className="filter-count">{count}</span>
          </button>
        ))}
      </div>
    </div>
  );
}